import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import useHandleErrors from "../../utils/user.utils";
import moment from "moment";
import { useUser } from '../../utils/userContext';


const OcrFile = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [filename, setFilename] = useState('');
    const handleErrors = useHandleErrors();
    const [note, setNote] = useState('OCR AI (Optical Character Recognition Artifical Intelligence)');
    const token = localStorage.getItem("token");
    const [files, setFiles] = useState([]);
    const { user } = useUser();
    const hasFetchedRef = useRef(false);


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setFilename(file.name);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            toast.error("Please select a file to upload.", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        const tokenResponse = await axios.post('https://workwise-fileupload-c2cedxcvf5gdhgdm.southindia-01.azurewebsites.net/token', new URLSearchParams({
            client_id: process.env.REACT_APP_CLIENT_ID,
            client_secret: process.env.REACT_APP_CLIENT_SECRET,
            // // scope: 'https://graph.microsoft.com/.default',
            grant_type: 'client_credentials',
            // withCredentials: true,
        }), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });

        console.log("tokenResponse", tokenResponse)

        const azureToken = tokenResponse.data.access_token;

        console.log("azureToken", azureToken)
        setUploading(true);
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);

            try {
                const azureResponse = await axios.post(
                    `https://workwise-fileupload-c2cedxcvf5gdhgdm.southindia-01.azurewebsites.net/upload/?doc_client=${'APX'}&token=${azureToken}`,
                    formData, {
                    headers: {
                        // Authorization: `Bearer ${azureToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
                );

                if (azureResponse.status === 200) {
                    setUploading(true);
                    setSelectedFile(null);
                    setFilename("");
                    toast.success("File uploaded successfully", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
                else {
                    throw new Error('Failed to upload the offer letter to Azure.');
                }
            } catch (error) {
                console.error("Error uploading file to Azure:", error);
            } finally {
                setUploading(false);
            }
        }
    };

    const fetchFiles = async () => {
        setUploading(true);
        try {
            const path = "/getZipDocuments";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.status === 200) {
                setFiles(response.data.zipDocuments);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setFiles([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setUploading(false);
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchFiles();
            hasFetchedRef.current = true;
        }
    }, []);

    const [isScanning, setIsScanning] = useState(true);
    const [scannedData, setScannedData] = useState('');

    useEffect(() => {
        const simulateScanning = () => {
            setIsScanning(true);
            setScannedData('');

            setTimeout(() => {
                setIsScanning(false);
                setScannedData('Lorem ipsum dolor sit amet, consectetur adipiscing elit.');
            }, 3000); // 3 seconds delay to simulate scanning
        };

        // Start scanning immediately on mount
        simulateScanning();

        // Continue scanning every 6 seconds (3 seconds scanning + 3 seconds viewing data)
        const interval = setInterval(simulateScanning, 6000);

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, []);


    return (
        <div>
            {uploading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">OCR Center</h3>
                        </div>
                        <div className="col-auto">
                            <a
                                href={'/Employees'}
                                className="btn btn-primary mt-lg-0 mt-4"
                            >
                                <i className="ri-user-star-line"></i> View All Employees
                            </a>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body bulk-upload-files">
                                    <div className="container">
                                        <div className="row vh-25 justify-content-center align-items-center">
                                            <div className="col-auto">
                                                <div className="no-data-wrapper">
                                                    <div className="no-data-found">
                                                        <i className="ri-folder-zip-fill"></i>
                                                        <div className="bounce">
                                                            <i className="ri-inbox-unarchive-fill"></i>
                                                        </div>
                                                        <p>{note}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="tab-content mb-4">
                                        <div>
                                            <div className="row justify-content-center">
                                                <div className="col-lg-8 col-md-8">
                                                    <div className="input-group">
                                                        <div className="custom-file">
                                                            <input
                                                                type="file"
                                                                className="custom-file-input"
                                                                onChange={handleFileChange}
                                                            />
                                                            <label
                                                                className="custom-file-label"
                                                                htmlFor="digitalsignature"
                                                            >
                                                                {filename ? filename : "OCR File"}
                                                            </label>
                                                        </div>
                                                        <div className="input-group-append position-relative">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary custom-dropdown-btn"
                                                                onClick={handleUpload}
                                                                disabled={uploading}
                                                            >
                                                                {uploading ? 'Uploading...' : 'Upload'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card ww-app-bg">
                                <div className="card-body">
                                    <span>
                                        <i className="ri-inbox-unarchive-fill"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body text-center">
                                    {/* Scanning GIF or Static Image */}
                                    {isScanning ? (
                                        <img
                                            src="https://via.placeholder.com/300x200?text=Scanning..."
                                            alt="Scanning"
                                            className="img-fluid"
                                        />
                                    ) : (
                                        <img
                                            src="https://via.placeholder.com/300x200?text=Data+Extracted"
                                            alt="Data Extracted"
                                            className="img-fluid"
                                        />
                                    )}

                                    {/* Scanned Data Placeholder */}
                                    {scannedData && (
                                        <div className="mt-4">
                                            <p className="text-success">Scanned Data: {scannedData}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OcrFile;
